/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Passkey_Last_ErrorInputs */



/**
* | output |
* | --- |
* | "This is your only passkey. Add another one before removing it." |
*
* @param {Partner_Security_Passkey_Last_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_passkey_last_error = /** @type {((inputs?: Partner_Security_Passkey_Last_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Passkey_Last_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das ist Ihr einziger Passkey. Fügen Sie einen weiteren hinzu, bevor Sie ihn entfernen.")
	return /** @type {LocalizedString} */ ("This is your only passkey. Add another one before removing it.")
});